export default __webpack_public_path__ + "static/media/fnc.7efbb39e.png";